import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <CommentsSection />
        <CarouselSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <IndexSection />
        <AboutSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}